import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Turns a web overflow/dropdown menu into a native action sheet. Each child
// link marked data-bridge-menu-target="item" becomes a row; selecting a row on
// the native side follows that link via Turbo.
//
//   .menu{data: { controller: "bridge--menu", "bridge-menu-title-value": "Options" }}
//     %a{href: edit_path, data: { "bridge-menu-target": "item" }} Edit
export default class extends BridgeComponent {
  static component = "menu";
  static targets = ["item"];
  static values = { title: String };

  connect() {
    super.connect();
    // The bridge dispatches native replies through this callback (there is no
    // event-name method dispatch), so the selection handler lives here. Native
    // replies with the chosen row index when the user taps an action-sheet row.
    this.send(
      "connect",
      { title: this.titleValue, items: this.items },
      (message) => {
        const index = message?.data?.index;
        const el = this.itemTargets[index];
        if (el) el.click();
      }
    );
  }

  get items() {
    return this.itemTargets.map((el, index) => ({
      index,
      title: (el.dataset.bridgeMenuLabel || el.textContent || "").trim(),
      destructive: el.dataset.bridgeMenuDestructive === "true",
    }));
  }
}
